<template>
  <div class="wx-login">
    <div class="iframe-warp">
      <iframe
        scrolling="no"
        width="450"
        height="400"
        frameborder="0"
        allowtransparency="true"
        :src="setSrc"
      ></iframe>
    </div>
    
  </div>
</template>

<script>
export default {
  computed: {
    setSrc() {
      var _url =
        "https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid=" +
        this.appid +
        "&agentid=" +
        this.agentid +
        "&redirect_uri=" +
        encodeURIComponent(window.location.protocol + '//' + this.redirect_uri) +
        "&state=" +
        this.state
      return _url;
    }
  },
  props: {
    //应用唯一标识，在微信开放平台提交应用审核通过后获得
    appid: String,
    agentid: [String, Number],
    //重定向地址，需要进行UrlEncode
    redirect_uri: String,
    //用于保持请求和回调的状态，授权请求后原样带回给第三方。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议第三方带上该参数，可设置为简单的随机数加session进行校验
    state: {
      type: String,
      default: "wechatwork"
    }
  }
};
</script>
<style lang="scss">
.wx-login{
  position: relative;
  z-index: 99;
}
</style>